import { PageHeader } from '@/components/ui/Card';
import { ThreadChat } from '@/components/creative/ChatBox';
import { useAuth } from '@/hooks/use-auth';

/** The clinic's chat with KAF: what the team marked client visible, and the
 *  clinic's own messages back. Per-creative questions live on each creative. */
export default function PortalChatPage() {
  const { user } = useAuth();
  if (!user?.client_id) return <div className="text-sm text-muted">Your account is not linked to a clinic yet.</div>;
  return (
    <div className="max-w-4xl mx-auto px-4 md:px-6 py-6">
      <PageHeader title="Chat with KAF" subtitle="Questions, requests, anything for the team. For a specific piece of content, use the chat on that creative." />
      <ThreadChat kind="client" id={user.client_id} tall />
    </div>
  );
}
